import { createStore } from '@zen/common-app-parts';
import useOperationsStore from './modules/useOperationsStore';

const { Provider, useStore } = createStore({
  useStoreHook: useOperationsStore,
  contextDisplayName: 'DexOperationsStoreContext',
});

export default {
  /**
   * @type {DexOperationsStoreProvider}
   */
  Provider,
  /**
   * @type {UseDexOperationsStore}
   */
  useStore,
};

/**
 * @typedef {({ dbClient: Object }) => void} DexOperationsStoreProvider
 */

/**
 * @typedef {() => OperationsStore} UseDexOperationsStore
 */

/**
 * @typedef {{
 *  state: {
      pkHash: string,
      transactions: Array,
      nonPendingTxCount: number,
      executions: Array,
      operations: Array,
      items: Array,
      filter: string,
      loading: {
        executions: boolean,
        transactions: boolean,
        items: boolean,
      },
    }
    actions: {
      setFilter: (filter: string) => void,
      reset: () => void,
      poll: {
        start: () => void,
        stop: () => void,
      },
    }
 * }} OperationsStore
 */
